<!-- src/components/Profile/SocialLinksForm.vue -->
<script setup>
const props = defineProps({
  formData: {
    type: Object,
    required: true,
  },
});

const form = props.formData; // atalho
</script>

<template>
  <div class="social-form">
    <h3 class="view-title">Redes sociais & contato</h3>
    <p class="view-subtitle">
      Defina quais redes você usa e como prefere que seu WhatsApp apareça no
      site.
    </p>

    <!-- 🟣 Linha 1: Telegram + Instagram -->
    <div class="form-group-row">
      <div class="form-group flex-1">
        <label for="telegramUsername">
          <i class="fab fa-telegram-plane mr-1 icon-telegram"></i>
          Telegram (opcional)
        </label>
        <input
          id="telegramUsername"
          type="text"
          v-model="form.telegramUsername"   
          class="input-base"
          placeholder="@usuário ou telefone"
        />
      </div>

      <div class="form-group flex-1">
        <label for="instagramUsername">
          <i class="fab fa-instagram mr-1 icon-instagram"></i>
          Instagram (opcional)
        </label>
        <input
          id="instagramUsername"
          type="text"
          v-model="form.instagramUsername"  
          class="input-base"
          placeholder="@usuario"
        />
      </div>
    </div>

    <!-- 🟣 Linha 2: LinkedIn -->
    <div class="form-group single-col">
      <label for="linkedInUsername">
        <i class="fab fa-linkedin mr-1 icon-linkedin"></i>
        LinkedIn (opcional)
      </label>
      <input
        id="linkedInUsername"
        type="text"
        v-model="form.linkedInUsername"     
        class="input-base"
        placeholder="URL do perfil"
      />
    </div>

    <!-- 🟣 Linha 3: Facebook -->
    <div class="form-group single-col">
      <label for="facebookUsername">
        <i class="fab fa-facebook-f mr-1 icon-facebook"></i>
        Facebook (opcional)
      </label>
      <input
        id="facebookUsername"
        type="text"
        v-model="form.facebookUsername"     
        class="input-base"
        placeholder="URL do perfil"
      />
    </div>

    <!-- Checkboxes WhatsApp -->
    <div class="flex-row-checkboxes mt-4">
      <div class="whatsapp-checkbox-inline">
        <input
          type="checkbox"
          id="phoneIsWhatsapp"
          v-model="form.phoneIsWhatsapp"     
          class="terms-checkbox"
        />
        <label
          for="phoneIsWhatsapp"
          class="terms-label flex items-center gap-1 cursor-pointer"
        >
          <i class="fab fa-whatsapp whatsapp-colored-icon"></i>
          Telefone é WhatsApp
        </label>
      </div>

      <div class="whatsapp-checkbox-group">
        <input
          type="checkbox"
          id="isWhatsappPublic"
          v-model="form.isWhatsappPublic"    
          class="terms-checkbox"
        />
        <label for="isWhatsappPublic" class="terms-label cursor-pointer">
          Autorizo exibir meu WhatsApp no site.
        </label>
      </div>
    </div>
  </div>
</template>

<style scoped>
.social-form {
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
}

.view-title {
  font-size: 1.15rem;
  font-weight: 600;
  color: var(--text-dark);
  margin: 0;
}
.view-subtitle {
  font-size: 0.9rem;
  color: var(--text-light);
  margin-top: 0.2rem;
  margin-bottom: 0.8rem;
}

/* 🔹 Linha com dois campos lado a lado (Telegram + Instagram) */
.form-group-row {
  display: flex;
  gap: 0.9rem;
  width: 100%;
}

.form-group label {
  margin-bottom: 0.35rem;
}

/* Facebook / LinkedIn com metade da largura da coluna */
.single-col {
  width: 50%;
  max-width: 50%;
}

/* Em telas pequenas, voltam pra 100% pra não esmagar demais */
@media (max-width: 600px) {
  .single-col {
    width: 100%;
    max-width: 100%;
  }

  .form-group-row {
    flex-direction: column;
  }
}

.flex-1 {
  flex: 1;
}

/* Ícones coloridos */
.icon-telegram {
  color: #229ed9;
}
.icon-instagram {
  color: #e4405f;
}
.icon-linkedin {
  color: #0a66c2;
}
.icon-facebook {
  color: #1877f2;
}
.whatsapp-colored-icon {
  color: #25d366;
  margin-right: 3px;
  margin-left: 4px;
}

/* Checkboxes */
.flex-row-checkboxes {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  flex-wrap: wrap;
}

.whatsapp-checkbox-inline {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.whatsapp-checkbox-group {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.terms-checkbox {
  width: 1rem;
  height: 1rem;
  border-radius: 4px;
  flex-shrink: 0;
  cursor: pointer;
}

.terms-label {
  font-size: 0.9rem;
  font-weight: 700;
  color: var(--text-dark);
}

.whatsapp-checkbox-group .terms-label {
  font-size: 0.875rem;
  font-weight: 500;
}
</style>
